export class ViewRules {
    static CREATE   = new ViewRules(0, "CREATE", true, true);
    static UPDATE   = new ViewRules(1, "UPDATE", false, true);
    static READONLY = new ViewRules(2, "READONLY", false, false);
    static COPY     = new ViewRules(3, "COPY", false, true);

    constructor(id, name, create, update) {
        this._id = id;
        this._name = name;
        this._create = create;
        this._update = update
    }

    get id() {
        return this._id;
    }

    get name() {
        return this._name;
    }

    get create() {
        return this._create;
    }

    get update() {
        return this._update;
    }

    equal(rule) {
        return this._id === rule._id;
    }

    clone() {
        let copy = new ViewRules();
        copy._id = this._id;
        copy._create = this._create;
        copy._update = this._update;
        return copy;
    }
}

